import { Component as ComponentContainer } from '@styles/layout';
import { InfoRowGroupComponent } from '@model/content';
import { InfoRowGroup } from '@components/help';

export const InfoRowGroupContainer = (props: InfoRowGroupComponent) => {
  return (
    <ComponentContainer>
      <InfoRowGroup {...props} />
    </ComponentContainer>
  );
};
